import { IFilePreview } from "../components/AttachmentsSelector/AttachmentsSelector";
import apiClient from "../helpers/api-client";
import {
  API_ENDPOINT_ADD_INVOICE,
  API_ENDPOINT_ALL_INVOICES,
  API_ENDPOINT_CLONE_TRANSACTION,
  API_ENDPOINT_DELETE_INVOICE,
  API_ENDPOINT_UPDATE_INVOICE,
  API_ENDPOINT_UPDATE_TRANSACTION,
} from "../helpers/constants";

export interface User {
  id: number;
  name: string;
}

export const searchTransactions = async ({
  fieldsToSearch,
}: {
  fieldsToSearch: any;
}) => {
  try {
    return await apiClient.get(API_ENDPOINT_ALL_INVOICES, {
      params: fieldsToSearch,
    });
  } catch (_e) {
    throw _e;
  }
};

export const getTransaction = async ({
  transactionId,
}: {
  transactionId: string;
}) => {
  const res = await searchTransactions({
    fieldsToSearch: { invoice: transactionId },
  });

  return res?.data;
};

export const updateTransactionsText = async ({
  transactionIds,
  fieldsToUpdate,
}: {
  transactionIds: Array<string>;
  fieldsToUpdate: any;
}) => {
  try {
    const formData = new FormData();
    formData.append("transactionIds", JSON.stringify(transactionIds));
    formData.append("fieldsToUpdate", JSON.stringify(fieldsToUpdate));

    const response = await apiClient.put(
      API_ENDPOINT_UPDATE_TRANSACTION,
      formData
    );

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Error al agregar transacción");
    }
  } catch (e) {
    throw e;
  }
};

export const updateTransactions = async ({
  transactionIds,
  fieldsToUpdate,
  files,
}: {
  transactionIds: Array<string>;
  fieldsToUpdate: any;
  files?: IFilePreview[];
}) => {
  try {
    const formData = new FormData();
    formData.append("transactionIds", JSON.stringify(transactionIds));
    if (files?.length) {
      files.forEach((file) => formData.append("files", file.file));
    }
    formData.append("fieldsToUpdate", JSON.stringify(fieldsToUpdate));

    const response = await apiClient.put(
      API_ENDPOINT_UPDATE_INVOICE,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Error al agregar transacción");
    }
  } catch (e) {
    throw e;
  }
};

export const updateTransaction = async ({
  transactionId,
  fieldsToUpdate,
  files,
}: {
  transactionId: string;
  fieldsToUpdate: any;
  files?: IFilePreview[];
}) => {
  return await updateTransactions({
    transactionIds: [transactionId],
    fieldsToUpdate,
    files,
  });
};

export const deleteTransactions = async ({
  transactionIds,
  sendToRecycle = true,
}: {
  transactionIds: Array<string>;
  sendToRecycle?: boolean;
}) => {
  return await apiClient.delete(`${API_ENDPOINT_DELETE_INVOICE}`, {
    data: {
      transactionIds,
      sendToRecycle,
    },
  });
};

export const deleteTransaction = async ({
  transactionId,
  sendToRecycle = true,
}: {
  transactionId: string;
  sendToRecycle?: boolean;
}) => {
  return await deleteTransactions({
    transactionIds: [transactionId],
    sendToRecycle,
  });
};

export const addTransaction = async ({
  transactionId,
  fieldsToSave,
  files,
}: {
  transactionId: string;
  fieldsToSave: any;
  files?: IFilePreview[];
}) => {
  try {
    const formData = new FormData();
    formData.append("invoice", transactionId);

    if (files?.length) {
      files.forEach((file) => formData.append("files", file.file));
    }
    formData.append("fieldsToSave", JSON.stringify(fieldsToSave));

    const response = await apiClient.post(API_ENDPOINT_ADD_INVOICE, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Error al agregar transacción");
    }
  } catch (e) {
    throw e;
  }
};

export const cloneTransaction = async ({
  transactionId,
  newCloneId,
  customizeFields,
  includeAttachments = false,
}: {
  transactionId: string;
  newCloneId: string;
  customizeFields: any;
  includeAttachments: boolean;
}) => {
  return await apiClient.post(API_ENDPOINT_CLONE_TRANSACTION, {
    transactionId,
    newCloneId,
    customizeFields,
    includeAttachments,
  });
};

export const shareTransactions = async ({
  shareWith,
  transactions = [],
  currencyCode,
}: {
  shareWith: string;
  transactions: Array<string>;
  currencyCode: string;
}) => {
  return await apiClient.post(`/share`, {
    transactions,
    shareWith,
    currencyCode,
  });
};
